import React, { useState } from 'react';

export default function AddByUrlForm({ onAddUrl }) {
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!url.trim()) return;

    setLoading(true);
    setMessage(null);
    try {
      await onAddUrl(url.trim());
      setMessage({ type: 'success', text: 'Card added successfully!' });
      setUrl('');
    } catch (err) {
      setMessage({ type: 'error', text: err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="add-url-form" onSubmit={handleSubmit}>
      <div className="url-input-group">
        <input
          type="url"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="Paste an eBay, Vinted, or CardMarket URL..."
          disabled={loading}
          required
        />
        <button
          type="submit"
          className="btn btn-primary"
          disabled={loading || !url.trim()}
        >
          {loading ? 'Adding...' : 'Add Card'}
        </button>
      </div>
      {message && (
        <div className={`form-message ${message.type}`}>
          {message.text}
        </div>
      )}
    </form>
  );
}
